<template>
  <div class="leftMenu">
        <div class="consoleTest">控制台</div>
        <!-- <div class="menu" v-for="(item, index) in menuList" :key="index" @click="tabMenu(index,item)" :class="{'active': active == item.index}">
          <img :src="item.img" :style="[{'width': item.with + 'px'},{'height': item.height + 'px'}]">
          <span>{{item.name}}</span>
        </div> -->
        <el-menu
          :default-active="active"
          :unique-opened="true"
          class="el-menu-vertical-demo"
          background-color="#1F222D"
          text-color="#fff"
          active-text-color="#fff"
          @select="handleSelect"
          >
          <div v-for="(item, index) in menuList" :key="index" v-if="item.children">
            <el-submenu :index="item.index">
            <template slot="title">
              <img :src="item.img" :style="[{'width': item.with + 'px'},{'height': item.height + 'px'}]">
              <span>{{item.name}}</span>
            </template>
            <el-menu-item-group title="" v-for="(subItem, subIndex) in item.children" :key="subIndex">
              <el-menu-item :index="subItem.index">{{ subItem.name }}</el-menu-item>
            </el-menu-item-group>
            </el-submenu>
          </div>
          <div v-else>
            <el-menu-item :index="item.index" v-if="!item.hidden">
              <img :src="item.img" :style="[{'width': item.with + 'px'},{'height': item.height + 'px'}]">
              <span>{{item.name}}</span>
              </el-menu-item>
          </div>
        </el-menu>
        
  </div>
</template>
<script>
  import {
    fetchIotMenu
  } from '@/api/api'
  export default {
    data() {
      return {
        active: 'MyApp',
        menuList: [
        {
          name: 'IOT平台',
          with: 20,
          height: 19,
          img: require('../../assets/images/iot@2x.png'),
          index:'IOT',
          hidden: true
        },
        {
          name: '应用管理',
          with: 20,
          height: 19,
          img: require('../../assets/images/icon_yygl@2x.png'),
          index:'Application',
          children: [
            {
              name: '我的应用',
              index:'MyApp',
            },
            {
              name: '授权应用',
              index:'AppMarket',
            },
            {
              name: '申请记录',
              index:'MyApply',
            },
          ]
        },
        {
          name: '供需管理',
          with: 20,
          height: 20,
          img: require('../../assets/images/icon_xqgl@2x.png'),
          index:'Demand',
          children: [
            {
              name: '我的需求',
              index:'MyDemand',
            },
            {
              name: '我的服务',
              index:'MyService',
            },
            {
              name: '我参与的',
              index:'MyJoin',
            },
          ]
        },
        {
          name: '服务管理',
          with: 23,
          height: 20,
          img: require('../../assets/images/icon_fwgl@2x.png'),
          index: 'Service',
          children: [
            {
              name: '咨询服务',
              index:'ServiceAdv',
            },
            // {
            //   name: '接口服务',
            //   index:'ServiceAPI',
            // },
            {
              name: '授权接口',
              index:'ServiceMarket',
            },
          ]
        },
        {
          name: '解决方案',
          with: 23,
          height: 20,
          img: require('../../assets/images/icon_jk@2x.png'),
          index: 'SolvePlan'
        },
        {
          name: '个人资料',
          with: 21,
          height: 20,
          img: require('../../assets/images/icn_grzl@2x.png'),
          index: 'PersonalData'
        },
        ]
      }
    },
    methods: {
      tabMenu(index,item) {
        this.$router.push({
          name: item.index,
          // params: { userId: 123 }
        })
      },
      handleSelect(key, keyPath) {
        this.active = key
        this.$router.push({
          name: key,
          // params: { userId: 123 }
        })
      },
      getIotMenu() {
        fetchIotMenu().then(res => {
          if(res.data.iotAuth === 1) {
            this.menuList[0].hidden = false
          }
        })
      }
    },
    watch: {
      $route: {
        handler: function (route) {
          const query = route.query;
          let path = this.$route.path.replace("/", "")
          if(path === 'ApiDetail') {
            this.active = 'ServiceMarket'
          }else {
            this.active = path
          }
          this.getIotMenu()
        },
        // immediate: true,
      },
    },
  }
</script>
<style scoped>
  .leftMenu {
    width: 250px;
    height: calc(100vh - 80px);
    background: #1F222D;
  }

  .consoleTest {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 80px;
    height: 80px;
    padding-left: 50px;
  }

  .menu {
    width: 300px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
  }

  .menu>img {
    margin-right: 10px;
    margin-left: 50px;
  }

  .menu>span {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
  }

  .active {
    background: #1B284B;
  }

  .leftMenu /deep/ .el-menu-item.is-active {
    background:rgba(27, 40, 75, 1)!important;
  }
  .el-menu{
    width: 100%!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/console/menu.vue